import React from 'react';
import { TableCellProps } from '../../../types/search';
import { moneyFormat } from '../utils/tableCellUtils';

const PortalCellTotal: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  const totalAmount = moneyFormat(value);

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--total`}>
      <p className="portal-cell__mobile-label">Total</p>
      <p>{totalAmount}</p>
    </div>
  );
};

export default PortalCellTotal;
